import messages from './cms.json' with { type: 'json' };

export const cmsEn: Readonly<typeof messages> = messages;
